import React, { Component } from 'react';
import './style.css';
import {
  Radiobutton,
  Checkboxes,
  HeaderQuestion,
  NextQuestionButton,
  TextForm
} from '../../components';
import { URL_START } from '../../constants';
import { translate } from 'react-i18next';

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.question.answer };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  handleChange(value) {
    this.setState({ value: value });
  }

  handleChangeText(event) {
    this.setState({ value: event.target.value });
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.setState({ value: nextProps.question.answer });
  }

  render() {
    let Element = Radiobutton;
    let handleChange = this.handleChange;
    switch (this.props.question.value_type) {
      case 'Checkbox':
        Element = Checkboxes;
        break;

      case 'Text':
        Element = TextForm;
        handleChange = this.handleChangeText;
        break;

      case 'Radio':
      default:
        Element = Radiobutton;
        break;
    }

    return (
      <div className="card-body">
        <HeaderQuestion
          text=""
          description={this.props.question.question}
          skip={this.props.skip}
        />
        <div>
          <Element
            answers={this.props.question.answers_questions}
            value={this.state.value}
            handleSubmit={this.handleSubmit}
            handleChange={handleChange}
          />
        </div>
        <NextQuestionButton
          to={URL_START + '/' + this.props.projectObjectUuid + '/'}
          onClick={() =>
            this.props.save(this.state.value, this.props.question.uuid)
          }
          disabled={!this.state.value.length}
        />
      </div>
    );
  }
}

export default translate('translations')(Question);



// WEBPACK FOOTER //
// ./src/preference/components/Question/index.js